import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Button, Modal } from 'react-bootstrap';

import DurationFormatter from '../utils/duration';
import AutoUserInput from './AutoUserInput';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import timeActions from '../actions/timeActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';
import Spinner from "./Spinner";

require.ensure([], () => {
    require('./ListPill.less');
    require('./Material-Design-Iconic.less');
});

class ListPillDialog extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.props.dispatch(timeActions.getTimeSpentOnTaskByUser(this.props.task.id, this.props.currentUser.id));
        this.state = {
            aliasChanged: false,
            alias: this.props.task.alias
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        /*this.props.dispatch(userTaskActions.loadByUser(this.props.currentUser.id));*/
        if (this.refs.aliasInput)
            ReactDOM.findDOMNode(this.refs.aliasInput).select();
    }

    componentWillReceiveProps = (nextProps) => {
        this.forceUpdate();
        this.setState({
            alias: this.props.task.alias
        });
    }

    // EVENT HANDLERS

    handleAliasChange = (event) => {
        this.setState({
            alias: event.target.value,
            aliasChanged: true
        }, this.validateAlias);
    }

    handleDelete = () => {
        this.props.deleteFloatingTask();
    }

    handleEditManagerButton = () => {
        this.setState({
            editManager: true
        }, () => {
            ReactDOM.findDOMNode(this.refs.managerInput.refs.userField).focus();
        });
    }

    handleManagerSelect = (payload) => {
        this.setState({
            newPm: payload.id,
            managerError: false,
            manager: payload.givenName + ' ' + payload.surname
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === 'Enter' && this.state.aliasChanged) {
            this.handleSave();

            keyEvent.stopPropagation();
            keyEvent.preventDefault();
        }
    }

    handleSave = () => {
        if (this.props.task.isFloatingTask) {
            if (this.state.aliasError) {
                return;
            }
            let newAlias = this.state.alias.trim();
            this.props.dispatch(userTaskActions.updateAlias(this.props.task.userTaskID, newAlias));

        }   else    {
            if (this.state.newPm === undefined) {
                this.props.onRequestHide();
                return;
            }   else    {
                let manager = {
                    id: this.state.newPm,
                    name: this.state.manager
                };
                this.props.task.managerName = manager.name;
                this.props.dispatch(floatingTaskActions.reassign(this.props.task.id, manager, ""));
            }
        }
        this.props.onRequestHide();
    }

    // OTHER METHODS

    validateAlias = () => {
        if (this.state.alias.length > 32) {
            this.setState({
                aliasError: true
            });
            return;
        }

        let aliasError = false;

        for (let i = 0; i < this.props.existingAliases.length; i++) {
            if (this.props.existingAliases[i].toLowerCase() === this.state.alias.trim().toLowerCase() && (!this.props.task.alias || (this.state.alias.trim().toLowerCase() !== this.props.task.alias.toLowerCase()))) {
                aliasError = true;
                break;
            }
        }

        this.setState({
            aliasError: aliasError
        });
    }

    // RENDER METHOD

    render = () => {

        let isFloatingTask = this.props.task.isFloatingTask;

        let createdAt = null;

        if (this.props.task.createdAt) {
            let createdAtTokens = this.props.task.createdAt.split("T");
            createdAt = createdAtTokens[1].substring(0, 8) + " on " + createdAtTokens[0];
        }

        return (
            <Modal show={true} onKeyPress={this.handleKeyPress} className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog new-floating">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" style={{wordWrap : "break-word"}}>{this.props.task.projectName}</h5>
                            <h4 className="modal-title" style={{wordWrap : "break-word"}}>{this.props.task.name}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-horizontal">
                                <div className="form-group">
                                    <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Manager:</label>
                                    <div className="col-md-7 col-sm-7 noborder">
                                        {
                                            this.state.editManager ?
                                            <AutoUserInput
                                                text={this.props.task.managerName}
                                                keepAfterClick
                                                disableTab
                                                users={this.props.pmUsers}
                                                handleFunction={this.handleManagerSelect}
                                                placeholder="Responsible PM if known"
                                                forceInitialPopup={false}
                                                enableClear
                                                ref="managerInput"/>
                                            : this.props.task.managerName
                                        }
                                    </div>
                                    <div className="col-md-1">
                                        {
                                            isFloatingTask && !this.props.task.returned ? <span style={{"cursor" : "pointer"}} onClick={this.handleEditManagerButton} className="md-mode-edit pull-right"/> : null
                                        }
                                    </div>
                                </div>
                                {
                                    !isFloatingTask ?
                                    <div className="form-group">
                                        <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Approver:</label>
                                        <div className="col-lg-6 col-md-7 col-sm-7">
                                            <p>{this.props.task.approverName ? this.props.task.approverName : "Line Manager"}</p>
                                        </div>
                                    </div> :null
                                }
                                <div className="form-group">
                                    <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Created at:</label>
                                    <div className="col-lg-6 col-md-7 col-sm-7">
                                        <p>{createdAt}</p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Description:</label>
                                    <div className="col-lg-6 col-md-7 col-sm-7">
                                        <p style={{ wordWrap: "break-word" }}>{this.props.task.description}</p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Quota:</label>
                                    <div className="col-lg-6 col-md-7 col-sm-7">
                                        <p>{ !this.props.task.userQuota  ? '∞' : Math.trunc(this.props.task.userQuota / 60) + "h"}</p>
                                    </div>
                                </div>
                                { isFloatingTask && this.props.task.returned ?
                                    <div className="form-group">
                                        <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Returned with message:</label>
                                        <div className="col-lg-6 col-md-7 col-sm-7">
                                            <p>{this.props.task.returnMessage}</p>
                                        </div>
                                    </div>
                                    : null
                                }
                                {
                                    !isFloatingTask && !this.props.loading ?
                                        <div className="form-group">
                                            <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Total used:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <p>{ DurationFormatter.format(this.props.regularTimeSpent ? this.props.regularTimeSpent : 0) } + { DurationFormatter.format(this.props.timeOvertimeSpent ? this.props.timeOvertimeSpent : 0) + " overtime"}</p>
                                            </div>
                                        </div> : null
                                }
                                {
                                    !isFloatingTask && this.props.loading ?
                                        <div className="form-group">
                                            <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Total used:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <Spinner/>
                                            </div>
                                        </div> : null
                                }
                                {
                                    !isFloatingTask ?
                                    <div className={this.state.aliasError ? "form-group has-error" : "form-group"}>
                                        <label className="col-md-4 col-sm-5 control-label">My alias:</label>
                                        <div className="col-lg-6 col-md-7 col-sm-7">
                                            <input ref="aliasInput" type="text" className="form-control" value={this.state.alias ? this.state.alias : ""} onChange={this.handleAliasChange} />
                                        </div>
                                    </div> : null
                                }
                                {
                                  !isFloatingTask && !this.props.loading ?
                                    <div className="form-group">
                                      <label className="col-md-4 col-sm-5 control-label" style={{marginTop: "-7px"}}>Task ID:</label>
                                      <div className="col-lg-6 col-md-7 col-sm-7">
                                        <p>{this.props.task.id}</p>
                                      </div>
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            { this.state.aliasChanged || this.state.editManager ? <Button name="save" block={true} onClick={this.handleSave}>Save</Button> : null }
                            <Button name="close" block={true} onClick={this.props.onRequestHide}>Close</Button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

ListPillDialog.propTypes = {
    createLogEntry: PropTypes.func,
    createTimer: PropTypes.func,
    deleteFloatingTask: PropTypes.func,
    dispatch: PropTypes.func,
    existingAliases: PropTypes.array,
    infoUserTask: PropTypes.object,
    onRequestHide: PropTypes.func,
    pmUsers: PropTypes.array,
    task: PropTypes.object,
    timesheet: PropTypes.object
};

ListPillDialog.defaultProps = {
    existingAliases: []
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        regularTimeSpent: state.time.timeSpent,
        timeOvertimeSpent: state.time.timeOvertimeSpent,
        loading: state.time.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListPillDialog);



/** WEBPACK FOOTER **
 ** ./src/app/components/ListPillDialog.js
 **/